import { Store } from 'libx'

export default class MagicLinkStore extends Store {
  get magicLinkAPI() {
    return this.rootStore.api.magicLink
  }

  constructor({ rootStore }) {
    super({ rootStore })
  }

  async request(workspaceId, email) {
    return this.magicLinkAPI.request({ workspace_id: workspaceId, email })
  }
}
